import { toDateKeyInBrasilia } from "./dateBrasilia";

function isWithdrawRequestedEntry(item) {
  const status = String(item?.status || "").trim().toUpperCase();
  const origin = String(item?.origin || "").trim().toUpperCase();
  const entryType = String(item?.entry_type || "").trim().toUpperCase();

  return (
    status === "WITHDRAW_REQUESTED" ||
    status === "REQUESTED" ||
    (entryType === "DEBIT" && origin === "WITHDRAW" && (!status || status === ""))
  );
}

function isPendingEntry(item) {
  const status = String(item?.status || "").trim().toUpperCase();
  return status === "PENDING" || status === "AWAITING_CONFIRMATION";
}

export function shouldShowLicensedLedgerEntry(item, referenceDate = new Date()) {
  const entryDateKey = toDateKeyInBrasilia(item?.entry_date || item?.created_at);
  if (!entryDateKey) return true;

  const todayKey = toDateKeyInBrasilia(referenceDate);
  if (!todayKey) return true;

  if (entryDateKey !== todayKey) return true;
  return isWithdrawRequestedEntry(item) || isPendingEntry(item);
}

export function filterLicensedLedgerEntries(items, referenceDate = new Date()) {
  const list = Array.isArray(items) ? items : [];
  return list.filter((item) => shouldShowLicensedLedgerEntry(item, referenceDate));
}
